<template>
  <div v-on="$listeners" class="app-list-item-content" :class="{ row }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AppListItemContent',

  props: {
    row: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.app-list-item-content {
  display: flex;
  flex-direction: column;
  flex: 1;

  &.row {
    flex-direction: row;
    gap: 1.25rem;
  }

  > small {
    font-size: 80%;
  }
}
</style>
